.note-title {
  font: use-font-secondary("700 18px/24px");
  margin: 0;

  &[data-urgent='true'] {
    color: var(--palette-accent-urgent);
  }
}